import { iconList } from "icomoon-react";
import iconSet from "./selection.json";
export const ICON_NAMES = iconList(iconSet);
export var IconSizes;
(function (IconSizes) {
    IconSizes["small"] = "16px";
    IconSizes["medium"] = "24px";
    IconSizes["large"] = "32px";
    IconSizes["xlarge"] = "48px";
})(IconSizes || (IconSizes = {}));
export var IconVariants;
(function (IconVariants) {
    IconVariants["neutral"] = "neutral";
    IconVariants["primary"] = "primary";
    IconVariants["secondary"] = "secondary";
    IconVariants["positive"] = "positive";
    IconVariants["negative"] = "negative";
})(IconVariants || (IconVariants = {}));
export var IconStyles;
(function (IconStyles) {
    IconStyles["full"] = "full";
    IconStyles["outline"] = "outline";
})(IconStyles || (IconStyles = {}));
export const noColors = ["mastercard_logo"];
//# sourceMappingURL=constants.js.map